import { z } from 'zod';

/** One fixture in a grid cell, from the perspective of the row's club. */
export const FdrFixture = z.object({
  opponent: z.string(),
  isHome: z.boolean(),
  difficulty: z.number().int().min(1).max(5),
});
export type FdrFixture = z.infer<typeof FdrFixture>;

/**
 * One (club, gameweek) cell. `fixtures` is the honest representation of the
 * gameweek — empty means a blank, one entry a normal match, two or more a
 * double. Never padded with a placeholder.
 */
export const FdrCell = z.object({
  gameweek: z.number().int(),
  fixtures: z.array(FdrFixture),
});
export type FdrCell = z.infer<typeof FdrCell>;

/** One club's row across the grid's gameweek window. */
export const FdrRow = z.object({
  club: z.string(),
  cells: z.array(FdrCell),
  /** Mean difficulty across this club's actual fixtures in the window,
   * rounded to one decimal. `null` when the club has no fixtures at all in
   * the window. */
  averageDifficulty: z.number().nullable(),
  /** How many fixtures `averageDifficulty` was taken over — lets the caller
   * tell a good average from a blank-inflated one. */
  fixtureCount: z.number().int().min(0),
});
export type FdrRow = z.infer<typeof FdrRow>;

/** The full fixture-difficulty grid: clubs down the side, gameweeks across
 * the top. */
export const FdrGrid = z.object({
  fromGameweek: z.number().int(),
  gameweeks: z.array(z.number().int()),
  rows: z.array(FdrRow),
});
export type FdrGrid = z.infer<typeof FdrGrid>;
